module.exports = __webpack_public_path__ + "static/media/expert (9).6c1551cc.png";